import type { Testimonial } from '../types/product';

export const testimonials: Testimonial[] = [
  {
    name: 'Emily Carter',
    perspective: 'Nursing student, United States',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/d7c3d909-109c-413d-9a58-456c84276a67.jpg',
    quote:
      'I used to jump between different ECG charts and lecture notes whenever I wanted to review a rhythm. Having the main concepts organized into separate volumes makes it much easier to follow a consistent study routine. The rhythm comparison tables are exactly the kind of resource I want to keep nearby.',
  },
  {
    name: 'Daniel Moreau',
    perspective: 'New graduate nurse, Canada',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/50c107a7-9f0b-4e1c-9443-de54f72127a1.jpg',
    quote:
      'The step-by-step interpretation workbook is the type of resource I wish I’d had when I started studying cardiac monitoring. I like working through each component of a tracing instead of immediately trying to guess the rhythm.',
  },
  {
    name: 'Keisha Williams',
    perspective: 'Emergency department nurse, United States',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/d5f91df5-61ff-4e20-9803-1593ee8bbebf.jpg',
    quote:
      '12-lead ECG interpretation can feel overwhelming because there are so many concepts to connect. A visual guide that explains lead orientation, waveforms, and interpretation principles in a consistent order is useful for focused review.',
  },
  {
    name: 'James Whitfield',
    perspective: 'Critical care nurse, United Kingdom',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/e91486a1-0b3c-4963-aaa6-4205b477d1b4.jpg',
    quote:
      'The arrhythmia comparison atlas is especially helpful for reviewing similar-looking rhythms. Having the distinguishing characteristics side by side makes the material easier to navigate.',
  },
  {
    name: 'Sarah Mitchell',
    perspective: 'Registered nurse, Australia',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/535c39b5-b6e4-4685-bc43-55d475f1697c.jpg',
    quote:
      'I appreciate study resources that include practice cases and explanations rather than just definitions. Working through simulated ECG examples and reviewing my reasoning makes my study sessions more purposeful.',
  },
];
